import { useTranslation } from 'react-i18next';
import { KoobConfirmationModal } from '@koob/ui';

/** Asks before an experience longer than the free days pushes the trip out. */
export default function ComposeOverlapModal({
  overlapingExperience,
  onCancel,
  onConfirm,
}) {
  const { t } = useTranslation('tripDesigner');

  if (!overlapingExperience) return null;

  return (
    <KoobConfirmationModal
      open={!!overlapingExperience}
      setOpen={onCancel}
      onConfirm={onConfirm}
      title={t('compose.overlapModal.title')}
      confirmLabel={t('compose.overlapModal.confirm')}
      cancelLabel={t('compose.overlapModal.cancel')}
    >
      <div>
        <p className="text-sm leading-relaxed text-gray-600">
          {t('compose.overlapModal.description', {
            duration: overlapingExperience.duration,
            availableDays: overlapingExperience.availableDays,
            count: overlapingExperience.availableDays,
          })}
        </p>
      </div>
    </KoobConfirmationModal>
  );
}
